import React, { useEffect, useRef, useState } from 'react';
import history from '../../../history';
import './Index.css';
import LcDropDown from '../../Generic/LcDropDown';
import LcIconLink from '../../Generic/LcIconLink';
import SideModal from '../SideModal/SideModal';
import { InputField } from '../../Form/Input';
import moment from 'moment';
import 'moment/locale/pt-br';

//Redux
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../store/index';
import { MenuState } from '../../../store/reducers/menuReducer';
import { UserState } from '../../../store/reducers/userReducer';
import { MessagesState } from '../../../store/reducers/messagesReducer';
import { PrefState } from '../../../store/reducers/prefReducer';

//MSAL
import { authProvider } from '../../../services/authProvider';

import { Store } from '../../../store/index';

//para o Vimeo
import { useSnackbar } from 'notistack';
import { useDebounce } from 'use-debounce';
import LcIcon from '../../Generic/LcIcon';
import LcLoading from '../../Generic/LcLoading';
import { SolicitationView } from '../../../models/SolicitationView';
import LastComments from './LastComments';
import FilterComments from './FilterComments';

import Modal from '../../Dialog/Modal'
import Tips from "../../../assets/documents/dicas.pdf";
import HelperComponent from './HelperComponent';
import SolicitationAttendantService from '../../../services/SolicitationAttendantService/SolicitationAttendantService';
import WorkService from '../../../services/WorkService/WorkService';
import { SolicitationFilterV2 } from '../../../models/SolicitationFilter';
import Pendencies from './Pendencies';
import { Period } from "../../../models/Period";
import { Field } from "../../../models/Field";

export interface Props {
    pageTitle?: string,
    header?: React.ReactNode,
    lastUpdate?: string,
    runUpdate?: Function,
    periodSelection?: {
        periods: Period[],
        customPeriod: Period,
        customPeriodType: string,
        onChange: Function
    },
    selection?: {
        selections: Period[],
        onChange: Function
    },
    showTutorials: boolean
}

export const TopMenu: React.FC<Props> = (props) => {

    moment.locale('pt-br');
    const dispatch = useDispatch();
    const menu = useSelector<RootState, MenuState>(state => state.menu);
    const user = useSelector<RootState, UserState>(state => state.user);
    const msgs = useSelector<RootState, MessagesState>(state => state.msgs);
    const pref = useSelector<RootState, PrefState>(state => state.pref);

    const [searchResult, setSearchResult] = useState<any>();
    const [searchResultTopMenu, setSearchResultTopMenu] = useState<any[]>([]);
    const [counter, setCounter] = useState<number>(0);
    const [lastUpdate, setLastUpdate] = useState<Date>(new Date());
    const [waitingUpdating, setWaitingUpdate] = useState<boolean>(false);
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [searchTermDebounce] = useDebounce(searchTerm, 1000);
    const [loadingMessage, setLoadingMessage] = useState<string>('');
    const [selectedPeriod, setSelectedPeriod] = useState<Period>();
    const [selection, setSelection] = useState<Period>();
    const [customPeriod, setCustomPeriod] = useState<Period | undefined>(props.periodSelection?.customPeriod);
    const [showModalCustomPeriod, setShowModalCustomPeriod] = useState<boolean>(false);
    const [isLoadingNotification, setIsLoadingNotification] = useState(true);
    const [notificationViewResponses, setNotificationViewResponses] = useState<any[]>([]);
    const [notificationViewResponsesFiltered, setNotificationViewResponsesFiltered] = useState<any[]>([]);
    const [notificationViewResponsesVisible, setNotificationViewResponsesVisible] = useState<any[]>([]);
    const [badgeNotification, setBadgeNotification] = useState<{ number: number, status: string }>({ number: 0, status: '' })
    const [modalVisibleNotification, setModalVisibleNotification] = useState<boolean>(false);
    const [modalVisibleAbout, setModalVisibleAbout] = useState<boolean>(false);
    const [modalVisibleLastComments, setModalVisibleLastComments] = useState<boolean>(false);
    const [searchFieldVisible, setSearchFieldVisible] = useState<boolean>(false);
    const [fullscreen, setFullScreen] = useState<boolean>((document.fullscreenElement == null) ? false : true);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [open, setOpen] = React.useState(false);
    const [openUsageTips, setOpenUsageTips] = useState<boolean>(false)
    const [filter, setFilter] = useState<{ size: number, term: string, column: string, direction: string }>({ size: 1, term: "", column: "", direction: "asc" });
    const selectionRef = useRef<any>(null);
    const selectPeriodFiltersRef = useRef<any>(null);
    const helpOpenRef = useRef<any>(null);
    const solicitationAttendantService = new SolicitationAttendantService(props);
    const workService = new WorkService(props);
    // const [aproveSolicitationLength, setAproveSolicitationLength] = useState<number>(0);
    // const [massiveSolicitationLength, setMassiveSolicitationLength] = useState<number>(0);
    const [aproveAttendant, setAproveAttendant] = useState<SolicitationView[]>([]);
    const [massiveSolicitation, setMassiveSolicitation] = useState<SolicitationView[]>([]);
    // const [namedSolicitation, setNamedSolicitation] = useState<SolicitationView[]>([]);
    const [aproveSolicitation, setAproveSolicitation] = useState<SolicitationView[]>([]);
    const [tooltipTextNotification, setTooltipTextNotification] = useState<string>('');
    const [reloadPendencies, setReloadPendencies] = useState<boolean>(false);

    // useEffect(() => {
    //     async function GetAllWikiSubPages() {
    //         if (versionSelect.length == 1) {
    //             try {
    //                 releaseNotesService.GetAllWikiSubPages().then((response) => {
    //                     let localVersionSelect: { name: string, value: string }[] = [];
    //                     response.map((item: any, index: number) => {
    //                         let label = item.path.replace('/Release Notes/LiveCloud/Produção/', '');
    //                         localVersionSelect.push({ name: label, value: label });
    //                     });
    //                     versionSelect && setVersionSelect(localVersionSelect);
    //                 });
    //             } catch (e) {

    //             }
    //         }
    //     }
    //     GetAllWikiSubPages();
    // }, [user.ClientGroupSelected])

    useEffect(() => {
        //Filtrar o menu com os ítens permitidos
        let found = menu.items.filter(i =>
            i.id === '6F96AEFB-3676-4995-9512-A15A6C617E1E' ||
            // i.id === '6f743644-026d-4d3a-9e11-a06cec33fab9' ||
            i.id === 'FDD52775-0F3F-4D20-B5C0-E1AB463330D2'
        )

        setSearchResult(found);

    }, [searchTerm]);

    // const showSearchFieldVisible = () => {
    //     setSearchFieldVisible(!searchFieldVisible);
    //     let searchInput = document.getElementById('searchTerm');
    //     searchInput?.focus();
    // }

    // const getItemName = (item: any) => {
    //     if (item.extraData) {
    //         let ed = JSON.parse(item.extraData);
    //         return ed['lc11Titulo'] || item.name;
    //     }

    //     return item.name;
    // }

    // const refreshreplace = async () => {
    //     Store && Store.dispatch({ type: 'USER_UPDATE_REFRESH', payload: Math.random() });

    //     let counterPlus = counter + 1;
    //     setCounter(counterPlus);
    //     // setLastRoute(window.location.pathname);
    //     // history.replace(window.location.pathname);
    // };

    // const handleClickFirstItem = (item: any) => {
    //     dispatch({ type: 'MENU_SELECTED_UPDATE', payload: item });
    //     dispatch({ type: 'MENU_SUB_VISIBLE', payload: true });
    // }

    // const handleClickSecondItem = (itemA: any, itemB: any) => {

    //     dispatch({ type: 'MENU_SUB_VISIBLE', payload: false });

    //     dispatch({ type: 'MENU_SELECTED_UPDATE', payload: itemA });
    //     dispatch({ type: 'MENU_SUBSELECTED_UPDATE', payload: itemB });

    //     if (itemB.route !== '#') {
    //         history.push(`/${itemB.route}`);
    //     }
    //     else {
    //         history.push(`/${itemB.children[0].route}`);
    //     }
    // }

    // const handleClickLastItem = (itemA: any, itemB: any, itemC: any) => {
    //     dispatch({ type: 'MENU_SUB_VISIBLE', payload: false });
    //     dispatch({ type: 'MENU_SELECTED_UPDATE', payload: itemA });
    //     dispatch({ type: 'MENU_SUBSELECTED_UPDATE', payload: itemB });

    //     history.push(`/${itemC.route}`);
    // }

    //#region NOTIFICATION
    useEffect(() => {
        if (msgs && msgs.messages) {
            let _m = msgs.messages.filter(x => x.isRead == false)
            setNotificationViewResponses(msgs.messages);
            setNotificationViewResponsesFiltered(msgs.messages);
            setBadgeNotification({ number: _m.length, status: 'warning' });
        }
    }, [msgs.messages])

    // const loadNotifications = async () => {
    //     setIsLoadingNotification(true);

    //     const canGetMessages = !msgs || !msgs.lastUpdate || new Date().getTime() - new Date(msgs.lastUpdate).getTime() > 300000;

    // }

    // const GetLastUpdateTimeCache = () => {

    // }

    // const handleConfirmClose = (confirm: boolean) => {
    //     if (confirm == true) {
    //         enqueueSnackbar('Atualização dos dados em andamento.', {
    //             variant: 'warning',
    //             preventDuplicate: true,
    //             persist: false,
    //         })
    //         setWaitingUpdate(true);

    //         //cacheManagerServiceInstance.Refresh()
    //         //    .then((response: any) => {
    //         //        GetLastUpdateTimeCache();
    //         //        if (props.lastUpdate) {
    //         //            let datelastUpdate = props.lastUpdate as string
    //         //            let time = new Date(datelastUpdate);
    //         //            setLastUpdate(time);
    //         //        }
    //         //        enqueueSnackbar('A atualização dos dados da tela foi concluída com sucesso.', {
    //         //            variant: 'success',
    //         //            preventDuplicate: true,
    //         //            persist: false,
    //         //        })
    //         //        refreshreplace();
    //         //    })
    //         //    .catch(console.warn)
    //         //    .then(() => {
    //         //        setWaitingUpdate(false);
    //         //    });
    //     }
    //     setOpen(false);
    // }

    // useEffect(() => {
    //     if (user && user.ClientGroupSelected && user.ClientGroupSelected > 0)
    //         if (user && user.UserId) {
    //             loadNotifications()
    //         }

    // }, [user.ClientGroupSelected]);

    useEffect(() => {
        if (props.lastUpdate) {
            let datelastUpdate = props.lastUpdate as string
            let time = new Date(datelastUpdate);
            setLastUpdate(time);
        }
    }, [counter]);

    useEffect(() => {
        var filtered = notificationViewResponses
            .filter((p: any) =>
                filter.term == '' ||
                p.subject.toLowerCase().indexOf(filter.term) > -1 ||
                moment(p.notificationDateTime).format('DD/MM/YYYY').toLowerCase().indexOf(filter.term) > -1
            )
            .sort((a: any, b: any) => {
                if (filter.direction === 'asc') return (a[filter.column] > b[filter.column]) ? 1 : -1;
                else return (a[filter.column] > b[filter.column]) ? -1 : 1;
            });

        setNotificationViewResponsesFiltered(filtered);
        setNotificationViewResponsesVisible(filtered.slice(0, filter.size));
    }, [filter, notificationViewResponsesFiltered.length > 0]);

    // const filterAdvanced = {
    //     fields: [{ label: 'Assunto', name: 'assunto', type: 'text' }],
    //     onChange: (_filter: any, size: number) => setFilter({ ...filter, size: size, term: _filter[0].value.toLowerCase() })
    // };

    // const allreadyFiltered = {
    //     field: 'isRead',
    //     value: false,
    //     func: (params: any) => {
    //         let result: any[] = [];
    //         notificationViewResponses.map((item) => {
    //             if (item[params.field] == params.value) {
    //                 result.push(item);
    //                 return true;
    //             }
    //             return false;
    //         });
    //         setNotificationViewResponsesFiltered(result);
    //     }
    // }

    // const columnsNotification = [
    //     {
    //         field: 'subject', headerName: 'Título', width: "50%",
    //         renderCell: (row: any) => {
    //             return <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.subject}</div>;
    //         }
    //     },
    //     {
    //         field: 'notificationDateTime', headerName: 'Data', width: "40%",
    //         renderCell: (row: any) => {
    //             return <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}> {moment(row.notificationDateTime).format('DD/MM/YYYY')} </div>;
    //         }
    //     },
    //     {
    //         field: 'isRead', sort: true, width: "5%",
    //         renderCell: (row: any) => {
    //             if (!row.isRead) return <LcIconLink icon="ppi ppi-eye" tooltip="Não vista" color='#BEBEBE' />
    //             else return <span />
    //         }
    //     }
    // ];

    // const functionsTableModalNotificationGeneric = [
    //     {
    //         id: "e6ec9492-dda0-4944-90ce-1711729314b1",
    //         title: 'Gerenciar notificações',
    //         icon: 'ppi ppi-menu-alt-1',
    //         tooltip: "Gerenciar notificações",
    //         func: () => {
    //             history.push('/NotificationCenter');
    //         }
    //     }
    // ];

    //#region BUSCA PERIODO
    useEffect(() => {
        props.periodSelection && setSelectedPeriod(props.periodSelection.periods.find(ps => ps.default));

        let selectionActive = props.selection && props.selection.selections &&
            props.selection.selections.find(ps => {
                return ps.default === true
            });

        if (selectionActive) setSelection(selectionActive);

        // GetLastUpdateTimeCache();
    }, [props.selection]); //user.refreshFlag

    const onChangePeriod = (period: Period) => {
        setSelectedPeriod(period);
        props.periodSelection?.onChange(period);
    }

    const onChangeSelection = (period: Period) => {
        setSelection(period);
        dispatch({ type: "MENU_SELECTED_UPDATE", payload: period.fields })
    }

    const onChangePeriodCustom = (custom: any) => {
        // let { name, value } = custom;
        // let _customPeriod = customPeriod as any;
        // _customPeriod.fields.find((f: any) => f.name === name).value = value;

        // switch (_customPeriod.fields[0].name) {
        //     case 'day':
        //         {
        //             let newDate = moment(_customPeriod.fields[0].value + 'T00:00:00');
        //             _customPeriod.text = `[${newDate.format('L')}]`;
        //         }
        //         break;
        //     case 'month':
        //         {
        //             let newDate = moment(_customPeriod.fields[0].value + '-01T00:00:00');
        //             _customPeriod.text = `[${newDate.format("MMM [de] YYYY")}]`;
        //         }
        //         break;
        //     case 'year':
        //         {
        //             let newDate = moment(_customPeriod.fields[0].value + '-01-01T00:00:00');
        //             _customPeriod.text = `[${newDate.format("YYYY")}]`;
        //         }
        //         break;
        // }

        // setCustomPeriod(_customPeriod);

        let { name, value } = custom;
        let _customPeriod = customPeriod as any;
        _customPeriod.fields.find((f: any) => f.name === name).value = value;

        const dateField = _customPeriod.fields[0];

        const dateFormats = {
            day: { format: 'L', unit: 'T00:00:00' },
            month: { format: 'MMM [de] YYYY', unit: '-01T00:00:00' },
            year: { format: 'YYYY', unit: '-01-01T00:00:00' },
        };

        const { format, unit } = dateFormats[dateField.name];
        let newDate = moment(dateField.value + unit);
        _customPeriod.text = `[${newDate.format(format)}]`;

        setCustomPeriod(_customPeriod);
    }

    const submitCustomPeriod = () => {
        setShowModalCustomPeriod(false);
        setSelectedPeriod(customPeriod);
        props.periodSelection?.onChange(customPeriod);
    }
    //#endregion    

    // const getPageName = () => {

    //     let HeyHo_LastMenuItem = sessionStorage.getItem('HeyHo_LastMenuItem');

    //     //Recarregando do Reducer
    //     user.Menus && !menu.selectedSubItem && HeyHo_LastMenuItem &&

    //         user.Menus.forEach(itemA => {
    //             itemA.children.forEach((itemB: any) => {
    //                 if (itemB.id === HeyHo_LastMenuItem) {
    //                     dispatch({ type: 'MENU_SELECTED_UPDATE', payload: itemA });
    //                     dispatch({ type: 'MENU_SUBSELECTED_UPDATE', payload: itemB });
    //                 }
    //             })
    //         })

    //     return menu.selectedSubItem ? menu.selectedSubItem.name : props.pageTitle || '...';
    // }

    useEffect(() => {
        dispatch({ type: 'MENU_FULLSCREEN', payload: fullscreen });
    }, [fullscreen])

    const fullScreenMode = () => {
        if (fullscreen) {
            setFullScreen(false);
            document.exitFullscreen();
        }
        else {
            setFullScreen(true);
            document.body.requestFullscreen();
        }
    }

    // const searchItemMenu = (currentItemMenu: any, searchTerm: string) => {
    //     if (getItemName(currentItemMenu).toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0) {
    //         return true;
    //     }

    //     return false;
    // }

    // useEffect(() => {

    //     //Filtrar o menu com os ítens permitidos
    //     let found = menu.items.filter(i =>
    //         i.id === '6F96AEFB-3676-4995-9512-A15A6C617E1E' ||
    //         // i.id === '6f743644-026d-4d3a-9e11-a06cec33fab9' ||
    //         i.id === 'FDD52775-0F3F-4D20-B5C0-E1AB463330D2'
    //     )

    //     const searchResultTopMenu: any[] = [];

    //     found.map((iA: any, kA: number) => {
    //         const hasResultFirstLevel = searchItemMenu(iA, searchTermDebounce);
    //         if (hasResultFirstLevel) {
    //             const item = {
    //                 onClick: () => handleClickFirstItem(iA),
    //                 label: <div key={kA}><i className="ppi ppi-desktop-computer" /> {getItemName(iA)}</div>,
    //                 item: iA,
    //                 index: kA
    //             };
    //             searchResultTopMenu.push(item)
    //         } else {
    //             iA.children.map((iB: any, kB: number) => {
    //                 const hasResultSecondLevel = searchItemMenu(iB, searchTermDebounce);
    //                 if (hasResultSecondLevel) {
    //                     const item = {
    //                         onClick: () => handleClickSecondItem(iA, iB),
    //                         label: <div key={kB}><i className="ppi ppi-desktop-computer" /><span className="text-grey"> {getItemName(iA)}</span>  <i className="ppi ppi-chevron-right" />{getItemName(iB)}</div>,
    //                         item: iB,
    //                         index: kB
    //                     };
    //                     searchResultTopMenu.push(item)
    //                 } else {
    //                     iB.children.map((iC: any, kC: number) => {
    //                         const hasResultThirdLevel = searchItemMenu(iC, searchTermDebounce);
    //                         if (hasResultThirdLevel) {
    //                             const item = {
    //                                 onClick: () => handleClickLastItem(iA, iB, iC),
    //                                 label: <div key={kC}><i className="ppi ppi-desktop-computer" /><span className="text-grey"> {getItemName(iA)}</span> <i className="ppi ppi-chevron-right" /> <span className="text-grey">{getItemName(iB)}</span> <i className="ppi ppi-chevron-right" /> {getItemName(iC)}</div>,
    //                                 item: iC,
    //                                 index: kC
    //                             };
    //                             searchResultTopMenu.push(item);
    //                         }
    //                     })
    //                 }
    //             });
    //         }
    //     });

    //     setSearchResultTopMenu(searchResultTopMenu);

    // }, [searchTermDebounce]);

    // const GoToAgendamentos = () => {
    //     dispatch({ type: 'MENU_SELECTED_UPDATE', payload: null });
    //     dispatch({ type: 'MENU_SUBSELECTED_UPDATE', payload: null });
    //     dispatch({ type: 'MENU_SUB_VISIBLE', payload: false });
    //     sessionStorage.setItem('HeyHo_LastMenuItem', '');
    //     history.push('/Agendamentos/Criar')
    // }

    //#region Tutoriais
    // const [modalTutorialsVisible, setModalTutorialsVisible] = useState<boolean>(props.showTutorials);

    // useEffect(() => {
    //     setModalTutorialsVisible(props.showTutorials);
    // }, [props.showTutorials])

    // const tutorials = [
    //     {
    //         name: 'Abertura de Chamado',
    //         url: 'https://vimeo.com/571387703/34b7fe408c',
    //     },
    //     {
    //         name: 'Tech CSP',
    //         url: 'https://vimeo.com/571788301/242f998030',
    //     },
    //     {
    //         name: 'Novos Clientes SAAS/CSP',
    //         url: 'https://vimeo.com/572733557/0c23b8aac1',
    //     },
    //     {
    //         name: 'Novos Clientes EA/EAS',
    //         url: 'https://vimeo.com/572734187/41acc34494',
    //     },
    //     {
    //         name: 'Autenticação/Login',
    //         url: 'https://vimeo.com/570004625/9f8fb13cba',
    //     }
    // ];

    //#endregion

    // const onSortChange = (sortData: any) => {
    //     const { sort, size } = sortData;
    //     setFilter({ ...filter, column: sort.column, direction: sort.direction, size: size })
    // };

    // const loadMore = (size?: number) => {
    //     if (size) setNotificationViewResponsesVisible(notificationViewResponsesFiltered.slice(0, size))
    //     else {
    //         setNotificationViewResponsesVisible([...notificationViewResponsesVisible, ...notificationViewResponsesFiltered.slice(notificationViewResponsesVisible.length, notificationViewResponsesVisible.length + 10)])
    //     }
    // };

    const alterModalVisible = (value: boolean) => {
        setModalVisibleLastComments(value);
    }

    const [commentTypeList, setCommentsTypeList] = useState<number[]>([1,2,3,4]);

    const alterSetCommentType = (value: number) => {
        if (commentTypeList.includes(value)) {
            let types = commentTypeList.filter(type => type !== value);
            setCommentsTypeList([...types]);
        }
        else {
            setCommentsTypeList([...commentTypeList, value]);
        }
    }

    const handleShowHelp = () => {
        dispatch({ type: 'MENU_HELPER_VISIBLE', payload: true });
    }

    useEffect(() => {
        const openModalHelpDropdown = pref.dataLocal?.openModalHelpDropdown ?? false;

        if (openModalHelpDropdown) {
            if (!helpOpenRef.current) {
                let helpDropdown = document.getElementById("helpDropdown");
                helpDropdown && helpDropdown.click();
            }
        }
        else {
            if (helpOpenRef.current) {
                let helpDropdown = document.getElementById("helpDropdown");
                helpDropdown && helpDropdown.click();
            }
        }
    }, [pref.dataLocal?.openModalHelpDropdown])

    useEffect(() => {
        const openModalPeriodFilters = pref.dataLocal?.openModalPeriodFilters ?? false;

        if (openModalPeriodFilters) {
            if (!selectPeriodFiltersRef.current) {
                let periodElement: any = document.getElementById('selectPeriodFilters');
                periodElement && periodElement.click();
            }
        }
        else {
            if (selectPeriodFiltersRef.current) {
                let periodElement: any = document.getElementById('selectPeriodFilters');
                periodElement && periodElement.click();
            }
        }
    }, [pref.dataLocal?.openModalPeriodFilters]);

    const getWindowSize = () => {
        const { innerHeight } = window;
        return innerHeight;
    }

    const [windowHeight, setWindowHeight] = useState<number>(getWindowSize());

    useEffect(() => {
        let _profile = 0;

        if (!user.attendant && user.approver) _profile = 1;
        if (user.attendant && !user.approver) _profile = 2;
        if (user.attendant && user.approver) _profile = 3;

        dispatch({
            type: "MENU_ATTENDANT_ACCESS",
            payload: {
                Status: 1,
                IdUser: user.id,
                StartDate: moment(new Date()).format("yyyy-MM-DD") + " " + new Date().toLocaleTimeString(),
                EndDate: moment(new Date()).format("yyyy-MM-DD") + " " + new Date().toLocaleTimeString(),
                Profile: _profile,
                DefaultCustomer: user.defaultCustomer.id,
            }
        });

        dispatch({ type: 'MENU_HELPER_VISIBLE', payload: false });

        const handleWindowResize = () => setWindowHeight(getWindowSize());
        window.addEventListener('resize', handleWindowResize);

        return () => window.removeEventListener('resize', handleWindowResize);
    }, []);

    useEffect(() => {
        const openLastComments = pref.dataLocal?.openLastComments ?? false;
        setModalVisibleLastComments(openLastComments);
    }, [pref.dataLocal?.openLastComments]);

    useEffect(() => {
        if (window.location.pathname === '/' || window.location.pathname === '/Attendance') {
            // getAproveSolicitation();
            getAproval();
        }
    }, [])

    const getAproval = async () => {
        const approvalList = await GetApprovalListByUserId();
        await getAproveSolicitation(approvalList);
    }

    const GetApprovalListByUserId = async () => {
        try {
            var response = await workService.GetApprovalListByUserId(Number(user.id));
            return response.data;
        }
        catch (error) {

        }
    }

    const getAproveSolicitation = async (approvalList?: any[]) => {
        setReloadPendencies(true);

        const filter = {
            userId: user.id,
            assunto: "0",
            customerId: "0",
            idTeam: "0",
            attendantId: "0",
            requesterId: "0",
            idStatus: "102",
            incidentId: "0",
            IdsGroupService: "0",
            IdsFilterField: "0",
            IdsService: "0",
            TipoData: "0",
            dataInicio: moment(new Date()).subtract(2, "month").format("YYYY-MM-DD"),
            dataFinal: moment(new Date()).format("YYYY-MM-DD"),
            attendantType: "1,2",
            AproveMassive: "1"
        };

        try {
            const solicitationResponse = await solicitationAttendantService.GetFilterMultiAdvancedV2(filter as SolicitationFilterV2);

            const solicitationResponseAproval = solicitationResponse.data
                .filter((x: any) => x.workStatus === 14)
                .sort((a: any, b: any) => {
                    return new Date(b.registrationDate).getTime() - new Date(a.registrationDate).getTime();
                });

            let massive = solicitationResponse.data
                .filter((massive: any) => massive.processType === 9)
                .sort((a: any, b: any) => {
                    return new Date(b.registrationDate).getTime() - new Date(a.registrationDate).getTime();
                });

            massive = Object.values(massive.reduce((acc: any, obj: any) => {
                if (!acc[obj.id]) acc[obj.id] = obj;
                return acc;
            }, {}));

            const namedApproval = solicitationResponseAproval.filter(named => named.idResponsibleUser === user.id);
            const notNamedAproval = solicitationResponseAproval.filter(named => named.idResponsibleUser === null);

            const _notNamedAprovalSolicitation = notNamedAproval.filter(x => {
                const approval = approvalList?.find(y => y.id === x.idFlowApproval);

                if (approval && approval.optionalSolicitationNotification === 1) {
                    return x;
                }
            });

            // setNamedSolicitation(namedApproval);
            setMassiveSolicitation(massive);
            setAproveAttendant([...namedApproval, ...notNamedAproval]);
            setAproveSolicitation([...namedApproval, ..._notNamedAprovalSolicitation]);
            handleTextNotification([...namedApproval, ...notNamedAproval].length, massive.length, [...namedApproval, ..._notNamedAprovalSolicitation].length);
        }
        catch (error: any) {
            console.error(error);
        }

        setReloadPendencies(false);
    }

    // const handleTextNotification = (aproveLenght: number, massiveLength: number, named: number) => {
    //     if (window.location.pathname === '/') {
    //         setTooltipTextNotification(`${named} aprovação pendentes`);
    //     }
    //     else if (aproveLenght > 0 && massiveLength > 0) {
    //         setTooltipTextNotification(`${massiveLength} problema massivo <br/>
    //                                     ${aproveLenght} aprovações pendentes`);
    //     }
    //     else if (aproveLenght > 0 && massiveLength === 0) {
    //         setTooltipTextNotification(`${aproveLenght} aprovações pendentes`);
    //     }
    //     else if (massiveLength > 0 && aproveLenght === 0) {
    //         setTooltipTextNotification(`${massiveLength} problema massivo`);
    //     }
    //     else {
    //         setTooltipTextNotification('');
    //     }
    // }

    const handleTextNotification = (aproveLenght: number, massiveLength: number, named: number) => {
        const conditions = [
            {
                condition: window.location.pathname === '/',
                text: `${named} aprovação pendentes`
            },
            {
                condition: aproveLenght > 0 && massiveLength > 0,
                text: `${massiveLength} problema massivo <br/>${aproveLenght} aprovações pendentes`
            },
            {
                condition: aproveLenght > 0 && massiveLength === 0,
                text: `${aproveLenght} aprovações pendentes`
            },
            {
                condition: massiveLength > 0 && aproveLenght === 0,
                text: `${massiveLength} problema massivo`
            },
            {
                condition: true,
                text: ''
            }
        ];

        const result = conditions.find((condition) => condition.condition);

        setTooltipTextNotification(result?.text || "");
    };

    useEffect(() => {
        setModalVisibleLastComments(false);
    }, [menu.showHelper]);

    return (
        <div className={"menutop"}>
            <HelperComponent user={user} />

            <SideModal
                width={(window.screen.width > 600) ? '30rem' : '100%'}
                visible={modalVisibleNotification}
                header={"Suas pendências"}
                onClose={() => setModalVisibleNotification(false)}
                fixedHeader={true}
            >
                {
                    modalVisibleNotification &&
                    <LcLoading loading={reloadPendencies}>
                        <Pendencies
                            aproveSolicitation={aproveSolicitation}
                            aproveAttendant={aproveAttendant}
                            massiveSolicitation={massiveSolicitation}
                            getAproval={getAproval}
                            closed={setModalVisibleNotification}
                        />
                    </LcLoading>
                }
            </SideModal>

            <SideModal
                width={"35rem"}
                header={
                    <FilterComments
                        user={user}
                        alterSetCommentType={alterSetCommentType}
                        commentTypeList={commentTypeList}
                    />
                }
                fixedHeader={true}
                visible={modalVisibleLastComments}
                onClose={() => { setModalVisibleLastComments(false) }}
            >
                {
                    modalVisibleLastComments &&
                    <LastComments alterModalVisible={alterModalVisible} commentTypeList={commentTypeList} />
                }
            </SideModal>

            <Modal width={'100vw'} visible={openUsageTips} title={'Dicas de uso'} close={() => setOpenUsageTips(false)}>
                <div className='form'>
                    <iframe src={Tips} frameBorder="0" style={{ width: '100vw', height: '90vh' }} />
                </div>
            </Modal>

            <div className={"left"}>
                {/* <span className="pagetitle pc-only">{getPageName()}{props.pageTitle || 'Título...'}</span> */}
                <span className={"pagetitle pc-only"}>{props.pageTitle}</span>
                {
                    props.header && props.header
                }
                {
                    props.periodSelection &&
                    <>
                        <LcDropDown element={<span className={"select-period"}> &nbsp;{selectedPeriod?.text} <i className={"ppi ppi-chevron-down-alt"} /> </span>}>
                            {
                                props.periodSelection.periods.map((p, i) => {
                                    return <span key={i} className={"item"} onClick={() => onChangePeriod(p)}> {p.label} </span>
                                })
                            }
                            {
                                props.periodSelection.customPeriod &&
                                <>
                                    <hr />
                                    <span className={"item"} onClick={() => { setShowModalCustomPeriod(!showModalCustomPeriod) }}> Personalizado </span>
                                </>
                            }
                        </LcDropDown>

                        {
                            props.periodSelection &&
                            <SideModal header={"Período personalizado"} visible={showModalCustomPeriod} onClose={() => { setShowModalCustomPeriod(false) }}>
                                {
                                    props.periodSelection.customPeriod &&
                                    props.periodSelection.customPeriod.fields &&
                                    props.periodSelection.customPeriod.fields.map((field: Field, index) => {

                                        let max = '';
                                        if (props.periodSelection && props.periodSelection.customPeriodType) {
                                            switch (props.periodSelection.customPeriodType) {
                                                case 'date':
                                                case 'datetime-local':
                                                    max = new Date().toISOString().split('T')[0]
                                                    break;
                                                case 'time':
                                                    max = new Date().toISOString().split('T')[1]
                                                    break;
                                                case 'datetime':
                                                    max = new Date().toISOString();
                                                    break;
                                                case 'month':
                                                    max = new Date().toISOString().substring(0, 7);
                                                    break;
                                                default:
                                                    break;
                                            }
                                        }

                                        return <InputField
                                            key={index}
                                            name={field.name}
                                            label={field.label}
                                            type={props.periodSelection ? props.periodSelection.customPeriodType : 'date'}
                                            onChange={onChangePeriodCustom}
                                            max={max} />
                                    })
                                }
                                <button className={"lc-button"} onClick={submitCustomPeriod}> Consultar </button>
                            </SideModal>
                        }
                    </>
                }
                {
                    props.selection && props.selection.selections &&
                    <>
                        <LcDropDown
                            id={"selectPeriodFilters"}
                            maxHeight={'70vh'}
                            element={
                                <span
                                    className={"select-period"}
                                    ref={selectionRef}>&nbsp;{selection?.text}
                                    <i className={"ppi ppi-chevron-down-alt"} />
                                </span>}
                        >
                            {
                                props.selection.selections.map((p, i) => {
                                    return <span
                                        key={i}
                                        className={"item"}
                                        onClick={() => {
                                            onChangeSelection(p);
                                            if (props.selection) {
                                                if (props.selection.onChange) {
                                                    props.selection.onChange(p);
                                                }
                                            }
                                        }}
                                        ref={selectPeriodFiltersRef}
                                    >{p.label}</span>
                                })
                            }
                        </LcDropDown>
                    </>
                }
            </div>

            <div className={"right pc-only"}>
                <LcDropDown
                    element={
                        <div className={`input-search ${searchFieldVisible ? 'visible' : ''}`}>
                            <input
                                id={"searchTerm"}
                                type={"text"}
                                value={searchTerm}
                                onChange={(event) => { setSearchTerm(event.target.value) }}
                                placeholder="Busque por itens do menu" />
                            <i className={"link ppi ppi-x"} onClick={() => { setSearchTerm('') }} />
                        </div>
                    }
                    position={"right"}
                    trigger={"hover"}>
                    <div className="scrollable-v" style={{ width: '355px', maxHeight: '75vh' }}>
                        {
                            !searchTermDebounce
                                ? <span className={"text-grey"} style={{ fontSize: '0.8rem' }}> Aguardando o termo de busca... </span>
                                : searchResultTopMenu.map((item: any, kA: number) => {
                                    return <div key={kA} className={"item"} onClick={item.onClick}> {item.label} </div>
                                })
                        }
                        {
                            (searchTermDebounce && searchResultTopMenu.length === 0) &&
                            <span className={"text-grey"} style={{ fontSize: '0.8rem' }}> Nenhum registro encontrado </span>
                        }
                    </div>
                </LcDropDown>

                <LcIconLink
                    id={"08c952a1-51e0-41dc-b1b4-5ff439ae2ee2"}
                    tooltip={"Tela cheia"}
                    icon={"ppi ppi-expand"}
                    onClick={fullScreenMode} />
            </div>
            <div className={"right"}>
                {
                    ((window.location.pathname === '/' && aproveSolicitation.length > 0) ||
                        (window.location.pathname === '/Attendance' && (massiveSolicitation.length > 0 || aproveAttendant.length > 0))) &&
                    <LcIconLink
                        tooltip={tooltipTextNotification}
                        icon={(massiveSolicitation.length > 0 && window.location.pathname === '/Attendance') ? "ppi ppi-exclamation" : "ppi ppi-bell"}
                        notification={aproveAttendant.length > 0 || massiveSolicitation.length > 0}
                        notificationLength={
                            (window.location.pathname === '/')
                                ? aproveSolicitation.length
                                : (massiveSolicitation.length > 0)
                                    ? massiveSolicitation.length + aproveAttendant.length
                                    : aproveAttendant.length
                        }
                        colorNotification={(massiveSolicitation.length > 0) ? '#E64646' : "#FFB800"}
                        onClick={() => setModalVisibleNotification(true)}
                    />
                }
            </div>
            <div className={"right pc-only"}>
                {
                    (window.location.pathname === '/' || window.location.pathname === '/Attendance') &&
                    <LcIconLink
                        tooltip={"Últimos comentários"}
                        icon={"ppi ppi-chat-alt-2"}
                        onClick={() => setModalVisibleLastComments(true)} />
                }
                <LcIcon icon={"ppi ppi-divider-vertical"} color={"#B5B7C6"} />
                <LcDropDown element={<LcIconLink icon={"ppi ppi-dots-vertical"} />} position={"Left"} id={"helpDropdown"}>
                    {/* <span id="f0fd35" className="item" onClick={() => setModalVisibleAbout(true)}> Sobre </span>
                    <span id="" className="item" onClick={() => setModalTutorialsVisible(true)}> Tutoriais </span> */}

                    {
                        (window.location.pathname === '/' || window.location.pathname === '/Attendance') &&
                        <>
                            {
                                window.screen.width > 600 &&
                                <span id="" className={"item"} onClick={() => handleShowHelp()} ref={helpOpenRef}> Ajuda </span>
                            }

                            <hr />
                        </>
                    }

                    {/* <span id="" className="item" onClick={() => setModalTutorialsVisible(true)}> Tutoriais </span> */}
                    <span id={"tips"} className={"item"} onClick={() => setOpenUsageTips(true)}> Dicas de uso </span>
                    <span id={""} className={"item"} onClick={() => authProvider.LogOutMSSO()}> Sair do Hey!Ho! </span>
                </LcDropDown>
            </div>
        </div>
    );
}